import MobileDetect from 'mobile-detect';

const MobileChecker = () => {
  let flag = new MobileDetect(window.navigator.userAgent);
  return !!flag.mobile();
};

export default MobileChecker;



// WEBPACK FOOTER //
// ./src/features/shared/utils/MobileChecker.js